

























































import Vue, { PropType } from "vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import {
  AutoCompleteUserSearch,
  SearchUserObject
} from "@/interfaces/shared/auto_complete_user_search";
import { TranslateResult } from "vue-i18n";
import {
  GET_USER_INFO,
  USER_INFO,
  SELECTED_USERS,
  RESET_USERS
} from "@/store/modules/common/constants";
export default Vue.extend({
  name: "AutoCompleteUserSearch",
  data(): AutoCompleteUserSearch {
    return {
      selected_searched_user: [],
      searched_users: [],
      search_input: null
    };
  },
  computed: {
    ...mapGetters("common", {
      get_user: USER_INFO,
      fetch_users: SELECTED_USERS
    })
  },
  props: {
    hide_details: {
      type: Boolean,
      default: true
    },
    rules: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String as PropType<TranslateResult>
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    if (this.get_user?.length) {
      this.searched_users = this.get_user;
    }
    if (this.fetch_users?.length) {
      this.selected_searched_user = this.fetch_users;
    }
  },
  watch: {
    /**
     * Function to Fetch Users on the base of input
     */
    async search_input(value) {
      if (value !== null) {
        const result = await this.autocomplete_user_search(value);
        if (result?.length > 0) {
          const filteredResult = result.filter(
            (item: SearchUserObject) =>
              !this.selected_searched_user?.some(
                (selectedItem: SearchUserObject) => selectedItem?.id === item.id
              )
          );

          this.searched_users = [
            ...this.selected_searched_user,
            ...filteredResult
          ];
        }
        return;
      }
    },
    selected_searched_user(value) {
      if (value) {
        this.set_selected_users(value);
        this.$emit("searched_user", value);
      }
    }
  },
  methods: {
    ...mapActions("common", {
      autocomplete_user_search: GET_USER_INFO
    }),
    ...mapMutations("common", {
      set_selected_users: SELECTED_USERS,
      reset_users: RESET_USERS
    }),
    on_clear_selected_users() {
      this.reset_state();
      this.$emit("searched_user", []);
    },
    on_input() {
      this.search_input = null;
    },
    remove_selected_item(id: number) {
      this.selected_searched_user = this.selected_searched_user.filter(
        (item: SearchUserObject) => item.id !== id
      );
    },
    reset_state() {
      this.selected_searched_user = [];
      this.searched_users = [];
      this.search_input = null;
      this.reset_users();
    },
    display_name(item: SearchUserObject) {
      return `${item.first_name} ${item.last_name ? item.last_name : ""}`;
    }
  }
});
